/*
    BASIS - Regle d'achat "Briquet by Basis".
    Le briquet ne peut jamais etre achete seul : il faut au
    moins MIN_OTHER_CENTS (centimes) d'autres articles.
    Voir aussi le message + CSS dans snippets/cart-summary.liquid.
  */
  (function () {
    'use strict';

    var BRIQUET_PRODUCT_ID = 16143048966479;
    var MIN_OTHER_CENTS = 3500;
    var CLS = 'basis-briquet-blocked';
    var blocked = false;

    function evaluate(cart) {
      if (!cart || !cart.items) {
        blocked = false;
        document.documentElement.classList.remove(CLS);
        return;
      }
      var hasBriquet = false;
      var others = 0;
      cart.items.forEach(function (item) {
        if (item.product_id === BRIQUET_PRODUCT_ID) {
          hasBriquet = true;
        } else {
          var p = item.final_line_price;
          if (p == null) p = item.line_price;
          others += p || 0;
        }
      });
      blocked = hasBriquet && others < MIN_OTHER_CENTS;
      document.documentElement.classList.toggle(CLS, blocked);
    }

    function refresh() {
      var root = '/';
      if (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root) {
        root = window.Shopify.routes.root;
      }
      fetch(root + 'cart.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(evaluate)
        .catch(function () {});
    }

    function highlight() {
      var m = document.querySelector('.basis-briquet-msg');
      if (m && m.scrollIntoView) {
        m.scrollIntoView({ block: 'center' });
      }
    }

    document.addEventListener('cart:update', function (e) {
      var res = e && e.detail && e.detail.resource;
      if (res && res.items) {
        evaluate(res);
      } else {
        refresh();
      }
    });

    document.addEventListener('submit', function (e) {
      if (!blocked) return;
      var f = e.target;
      if (f && f.matches && f.matches('#cart-form')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        highlight();
      }
    }, true);

    document.addEventListener('click', function (e) {
      if (!blocked) return;
      if (!e.target.closest) return;
      var sel = '#checkout, [name="checkout"], .cart__checkout-button';
      if (e.target.closest(sel)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        highlight();
      }
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refresh);
    } else {
      refresh();
    }
  })();
